import api from "./index";

export async function signIn(body) {
  return api.post("/auth/local", body);
}

export async function signUp(body) {
  return api.post("/auth/local/sign-up", body);
}

export async function findPeople(body) {
  return api.post("/people/finder", body);
}

export async function loadSession() {
  return api.get("/auth");
}

export async function updatePerson(body) {
  return api.put(`/auth`, body);
}

export async function updatePersonPhoto(formData) {
  return api.put(`/auth`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function recoverPassword(body) {
  return api.post(`/auth/forgot-password`, body);
}

export async function definePassword(body) {
  return api.post(`/auth/reset-password`, body);
}

export async function requestChangeEmail(body) {
  return api.post(`/auth/request-email-change`, body);
}

export async function changeEmail(body) {
  return api.post(`/auth/change-email`, body);
}

export async function requestConfirmEmail(body) {
  return api.post(`/auth/request-email-confirmation`, body);
}

export async function confirmEmail(body) {
  return api.post(`/auth/confirm-email`, body);
}
